import { getLoggedOrPlannedAtWorkoutUtil } from '../../../../../modules/workout/model/utils/get-logged-or-planned-at'
import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'
import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'
import isLoggedWorkoutUtil from '../../../../../modules/workout/model/utils/is-logged'

import updateDataPlanAction from '../../../../plans/actions/update-data'
import getByIdPlanSelector from '../../../../plans/selectors/get-by-id'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import cloneWorkoutAction from '../clone'
import saveWorkoutAction from '../save'
import WORKOUTS_ANALYTICS_EVENT from '../../constants/analytics-event'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import { logUtil } from 'packages/src'
import { logEventAnalyticsUtil } from '../../../../../utils/analytics/log-event'

function copyWorkoutAction (params) {
  return async (dispatch, getState) => {
    const {
      domainListPath
    } = params
    const {
      id,
      shouldKeepPlan
    } = params
    const data = params.data || {}
    const workout = (
      params.workout || getByIdWorkoutSelector(id)(getState())
    )

    if (!workout) {
      logUtil('').warn('no workout')
      return
    }

    // if (
    //   isInStartedPlanWorkoutSelector(workout)(getState()) &&
    //   // On purpose @see WorkoutRow/Actions/index.js#handlePressCopy
    //   data[WORKOUT_KEY.PLAN_ID] !== null
    // ) {
    //   dispatch(
    //     copyWorkoutPlanAction({
    //       id,
    //       data
    //     })
    //   )
    //   return
    // }

    const updatePlan = () => {
      const plan = getByIdPlanSelector(getPlanIdWorkoutUtil(workout))(
        getState())
      if (!plan) {
        return
      }
      dispatch(updateDataPlanAction(plan))
    }

    // console.log('hmm')
    // if (isLoggedWorkoutUtil(workout)) {
    //   console.log('#1')
    //   dispatch(createFromLogWorkoutAction({
    //     id,
    //     data
    //   }))
    //   updatePlan()
    //   return
    // }

    const keysToOmit = [
      WORKOUT_KEY.LOGGED_AT,
      WORKOUT_KEY.RATING
    ]
    const isInPlan = isInPlanWorkoutUtil(workout)
    if (!isInPlan || !shouldKeepPlan) {
      keysToOmit.push(WORKOUT_KEY.PLAN_ID)
    }
    const newData = {
      [WORKOUT_KEY.PLANNED_AT]: (
        isLoggedWorkoutUtil(workout) && !isInPlan
          ? null
          : getLoggedOrPlannedAtWorkoutUtil(workout)
      ),
      ...(
        data || {}
      )
    }
    // const plannedAt = getPlannedAtWorkoutUtil(workout)
    // if (plannedAt) {
    //   data[WORKOUT_KEY.PLANNED_AT] = (
    //     getLoggedAtWorkoutUtil(workout) ||
    //     plannedAt
    //   )
    // }
    const newWorkout = await dispatch(cloneWorkoutAction({
      workout,
      domainListPath,
      data: newData,
      keysToOmit
    }))

    dispatch(saveWorkoutAction(getIdReduxUtil(newWorkout)))

    logEventAnalyticsUtil(WORKOUTS_ANALYTICS_EVENT.DUPLICATED, workout)

    if (isInPlan && shouldKeepPlan) {
      updatePlan()
    }

    return newWorkout
  }
}

export default copyWorkoutAction
